export const CALENDAR_CONNECTION_STATUS = {
  connected: 'connected',
  reauthorizationRequired: 'reauthorization_required',
} as const;

export interface CalendarConnectionApiResource {
  is_connected: boolean;
  google_account_email: string | null;
  status: string | null;
  last_synced_at: string | null;
}

export interface AuthorizationUrlApiResource {
  authorization_url: string;
}

export interface CalendarConnection {
  isConnected: boolean;
  googleAccountEmail: string | null;
  status: string | null;
  lastSyncedAt: string | null;
}

export interface ExternalCalendarEventApiResource {
  id: string;
  title: string;
  start: string;
  end: string;
  all_day: boolean;
}

export interface ExternalCalendarEvent {
  id: string;
  title: string;
  start: string;
  end: string;
  allDay: boolean;
}

export function mapApiResourceToExternalCalendarEvent(
  resource: ExternalCalendarEventApiResource
): ExternalCalendarEvent {
  return {
    id: resource.id,
    title: resource.title,
    start: resource.start,
    end: resource.end,
    allDay: resource.all_day,
  };
}

export function mapApiResourceToCalendarConnection(
  resource: CalendarConnectionApiResource
): CalendarConnection {
  return {
    isConnected: resource.is_connected,
    googleAccountEmail: resource.google_account_email,
    status: resource.status,
    lastSyncedAt: resource.last_synced_at,
  };
}
